import { render, staticRenderFns } from "./2Fa.vue?vue&type=template&id=4a16d664&scoped=true&"
import script from "./2Fa.vue?vue&type=script&lang=js&"
export * from "./2Fa.vue?vue&type=script&lang=js&"
import style0 from "./2Fa.vue?vue&type=style&index=0&id=4a16d664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a16d664",
  null
  
)

export default component.exports